import { render, staticRenderFns } from "./ModalCreatedTicket.vue?vue&type=template&id=2d56f1d0"
import script from "./ModalCreatedTicket.vue?vue&type=script&lang=js"
export * from "./ModalCreatedTicket.vue?vue&type=script&lang=js"
import style0 from "./ModalCreatedTicket.vue?vue&type=style&index=0&id=2d56f1d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports